import * as React from 'react';

const SvgTelefon = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.735 19.933 12.268 22.4a1.34 1.34 0 0 1-1.88.013c-.147-.146-.293-.28-.44-.426a37.88 37.88 0 0 1-3.72-4.36c-1.093-1.52-1.973-3.04-2.613-4.547-.627-1.52-.947-2.973-.947-4.36 0-.907.16-1.773.48-2.573.32-.814.827-1.56 1.533-2.227.854-.84 1.787-1.253 2.774-1.253.373 0 .746.08 1.08.24.346.16.653.4.893.746l3.093 4.36c.24.334.414.64.534.934.12.28.186.56.186.813 0 .32-.093.64-.28.947a4.533 4.533 0 0 1-.746.946L11.2 12.707a.713.713 0 0 0-.213.533c0 .107.013.2.04.307.04.106.08.186.107.266.24.44.653 1.014 1.24 1.707.6.693 1.24 1.4 1.933 2.107.133.133.28.266.413.4.534.52.547 1.373.014 1.906ZM29.294 24.44a3.387 3.387 0 0 1-.333 1.453c-.227.48-.52.934-.907 1.36-.653.72-1.373 1.24-2.187 1.574-.013 0-.026.013-.04.013-.786.32-1.64.493-2.56.493-1.36 0-2.813-.32-4.346-.973-1.534-.653-3.067-1.533-4.587-2.64-.52-.387-1.04-.773-1.533-1.187l4.36-4.36c.373.28.706.494.986.64.067.027.147.067.24.107.107.04.214.053.334.053.226 0 .4-.08.546-.226l1.014-1c.333-.334.653-.587.96-.747.306-.187.613-.28.946-.28.254 0 .52.053.814.173.293.12.6.294.933.52l4.413 3.134c.347.24.587.52.734.853.133.333.213.667.213 1.04Z'
      fill='#fff'
    />
  </svg>
);

export default SvgTelefon;
